// Admin-only request enrichment. No cookies, tokens or role grants are stored here.
import axios from 'axios';
import { useSyncExternalStore } from 'react';
let activeScope = null;
let installed = false;
const listeners = new Set();
let version = '';
export const setAdminRequestScope = scope => {
  activeScope = scope;
  const next = JSON.stringify(scope || {});
  if (next !== version) { version = next; listeners.forEach(fn => fn()); }
};
const subscribe = fn => { listeners.add(fn); return () => listeners.delete(fn); };
export const useAdminScopeVersion = () => useSyncExternalStore(subscribe, () => version, () => '');
export const getAdminViewAs = () => activeScope?.view_as || 'corporate';

export function installAdminScopeTransport() {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use(config => {
    if (activeScope && window.location.pathname.startsWith('/company-manager-dashboard')) {
      const url = new URL(config.url, config.baseURL || window.location.origin);
      if (url.origin === new URL(process.env.REACT_APP_BACKEND_URL).origin && url.pathname.startsWith('/api/')) {
        config.params = { ...config.params, ...Object.fromEntries(Object.entries(activeScope).map(([k, v]) => [`scope_${k}`, v || ''])) };
        config.necsScopeSignature = JSON.stringify(activeScope);
      }
    }
    return config;
  });
  axios.interceptors.response.use(response => {
    if (response.config.necsScopeSignature && response.config.necsScopeSignature !== JSON.stringify(activeScope)) {
      throw new axios.CanceledError('Superseded population request');
    }
    return response;
  });
  const original = window.fetch.bind(window);
  window.fetch = (input, options) => {
    if (!activeScope || !window.location.pathname.startsWith('/company-manager-dashboard')) return original(input, options);
    const url = new URL(typeof input === 'string' ? input : input.url, window.location.origin);
    const backend = new URL(process.env.REACT_APP_BACKEND_URL);
    if (url.origin !== backend.origin || !url.pathname.startsWith('/api/') || /^\/api\/(auth|geo|admin\/demo-suite|ops\/admin\/demo-seed)(\/|$)/.test(url.pathname)) return original(input, options);
    Object.entries(activeScope).forEach(([key, value]) => url.searchParams.set(`scope_${key}`, value || ''));
    const signature = JSON.stringify(activeScope);
    return original(input instanceof Request ? new Request(url, input) : url.toString(), options).then(response => {
      if (activeScope && signature !== JSON.stringify(activeScope)) throw new DOMException('Superseded population request', 'AbortError');
      return response;
    });
  };
}